/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./platform-view.vue?vue&type=template&id=d3c7dc10&scoped=true"
import script from "./platform-view.vue?vue&type=script&lang=js"
export * from "./platform-view.vue?vue&type=script&lang=js"
import style0 from "./platform-view.vue?vue&type=style&index=0&id=d3c7dc10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c7dc10",
  null
  
)

export default component.exports